module.exports = __webpack_public_path__ + "static/media/ic_pet1.ca3b0b60.png";